/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Dropdown, Navbar, Nav, Offcanvas } from "react-bootstrap";
import Logo from "../../assets/logo.webp";

import MenuIcon from "@iconscout/react-unicons/icons/uil-bars";
import { useDispatch, useSelector } from "react-redux";

import actions from "../../redux/actions/userAction";
import { toast } from "react-toastify";

const DashboardHeader = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userDetails = useSelector((state) => state?.user);

  useEffect(() => {
    if (userDetails) {
      if (!userDetails?.loggedIn) {
        toast.warn("Please login to account");
        navigate("/");
      }
    }
  }, [userDetails]);

  return (
    <header className="dashboard-header">
      <Navbar expand="lg">
        <div className="container" style={{ display: "block" }}>
          <div className="navigation">
            <div className="left-navigation">
              <div className="logo-box">
                <img src={Logo} className="header-logo" alt="Company Logo" />
              </div>
              <Navbar.Toggle aria-controls="responsive-navbar-nav">
                <MenuIcon color="#FFF" size="25" />
              </Navbar.Toggle>
              <Navbar.Offcanvas
                id="responsive-navbar-nav"
                className="mobile-menu"
              >
                <Offcanvas.Header className="mobile-menu-header" closeButton>
                  <img src={Logo} className="header-logo" alt="Company Logo" />
                </Offcanvas.Header>
                <Offcanvas.Body className="mobile-menu-body">
                  <Nav className="navigation-options">
                    {userDetails?.type === "admin" && (
                      <>
                        <Nav.Link
                          href="/unwind-street"
                          className="navigation-item"
                          active={
                            window.location.pathname === "/unwind-street"
                              ? true
                              : false
                          }
                        >
                          Unwind Street Leads
                        </Nav.Link>
                      </>
                    )}

                    {userDetails?.type === "super-admin" && (
                      <>
                        <Nav.Link
                          href="/contact-us"
                          className="navigation-item"
                          active={
                            window.location.pathname === "/contact-us"
                              ? true
                              : false
                          }
                        >
                          Contacts Us Leads
                        </Nav.Link>
                        <Nav.Link
                          href="/marketing-leads"
                          className="navigation-item"
                          active={
                            window.location.pathname === "/marketing-leads"
                              ? true
                              : false
                          }
                        >
                          Marketing Leads
                        </Nav.Link>
                        <Nav.Link
                          href="/google-workspace"
                          className="navigation-item"
                          active={
                            window.location.pathname === "/google-workspace"
                              ? true
                              : false
                          }
                        >
                          Google Workspace Leads
                        </Nav.Link>
                        <Nav.Link
                          href="/career"
                          className="navigation-item"
                          active={
                            window.location.pathname === "/career"
                              ? true
                              : false
                          }
                        >
                          Career Leads
                        </Nav.Link>
                        <Nav.Link
                          href="/aircall"
                          className="navigation-item"
                          active={
                            window.location.pathname === "/aircall"
                              ? true
                              : false
                          }
                        >
                          Aircall Leads
                        </Nav.Link>
                        {/* <Nav.Link
                          href="/blogs"
                          className="navigation-item"
                          active={
                            window.location.pathname === "/blogs" ? true : false
                          }
                        >
                          Blogs
                        </Nav.Link> */}
                        {/* <Nav.Link
                          href="/marketing-message"
                          className="navigation-item"
                          active={
                            window.location.pathname === "/marketing-message"
                              ? true
                              : false
                          }
                        >
                          Marketing Message
                        </Nav.Link> */}
                        {/* <Nav.Link
                          href="/unwind-street"
                          className="navigation-item"
                          active={
                            window.location.pathname === "/unwind-street"
                              ? true
                              : false
                          }
                        >
                          Unwind Street Leads
                        </Nav.Link> */}
                      </>
                    )}
                  </Nav>
                </Offcanvas.Body>
              </Navbar.Offcanvas>
            </div>
            {/* RIGHT NAVIGATION */}
            <div className="right-navigation">
              <Dropdown className="profile-dropdown">
                <Dropdown.Toggle>
                  <div className="profile-avatar">
                    <div className="admin-details">
                      <p>Administrator</p>
                      <h5>Roundtechsquare</h5>
                    </div>
                    <img
                      src={require("../../assets/logo.webp")}
                      alt="Profile"
                    />
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu className="profile-dropdown-menu">
                  <Dropdown.Item
                    href="/"
                    onClick={() => {
                      dispatch(actions.setLoggedIn(false));
                      dispatch(actions.setToken(null));
                      dispatch(actions.setLoggedIn(false));
                      dispatch(actions.setUser(null));
                    }}
                    className="menu-item"
                  >
                    Log out
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
      </Navbar>
    </header>
  );
};

export default DashboardHeader;
